import React from 'react';
import image from "../assets/images/skin_page.png";
import {Link} from "react-router";
import image1 from "../assets/images/skin1.png";
import image2 from "../assets/images/skin2.png";
import image3 from "../assets/images/skin3.png";
import image4 from "../assets/images/skin4.png";
import image5 from "../assets/images/skin5.png";
import image6 from "../assets/images/skin6.png";

const Skin = () => {
    return (
        <div>
            <div className={'w-full relative '}>
                <img src={image} alt="" className={'w-full pt-20'}/>
                <div className={'absolute top-0 left-0 w-full h-full bg-black opacity-[17%]'}></div>
                <p className={'absolute md:bottom-20 left-[40%] text-4xl bottom-1 '}>Skin Booster</p>
                <Link to={'/'}>
                    <div className={'absolute top-24 left-10 '}>
                        <svg width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M24.2 29.1199L17.68 22.5999C16.91 21.8299 16.91 20.5699 17.68 19.7999L24.2 13.2799"
                                  stroke="black" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                                  stroke-linejoin="round"/>
                        </svg>

                    </div>
                </Link>
            </div>


            <div className="bg-white py-12 px-6 md:px-12">
                {/* Section Title */}
                <section className="max-w-6xl mx-auto mb-16">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
                        {/* Left Content */}
                        <div>
                            <h2 className="text-2xl md:text-3xl  text-[#0C568E] mb-4">1. H2O Collagen
                                Booster</h2>

                            <h3 className="text-2xl   mb-4">Effect of H2O Collagen Booster</h3>
                            <ul className="list-disc list-inside text-gray-700 text-lg space-y-2 mb-6">
                                <li>Improve skin elasticity & Anti-wrinkle</li>
                                <li>Collagen production</li>
                                <li>Hydration</li>
                                <li>Smoothing & Skin tissue recovery</li>
                                <li>Improving pores</li>
                            </ul>

                        </div>
                        {/* Right Content */}
                        <div>
                            <img
                                src={image1}
                                alt="H2O Collagen Booster"
                                className="rounded-lg  w-full"
                            />
                        </div>
                    </div>

                    <h3 className="text-3xl   my-4">A strong Antioxidant chain with
                        Hydrolysed collagen</h3>
                    <p className="text-gray-700 text-lg leading-relaxed mb-4">
                        H2O Collagen Booster is a Skin Booster solution with a strong antioxidant chain made up
                        of the optimal combination of high content vitamins, amino acids, peptides,
                        antioxidants, and hyaluronic acid polymers required to prevent skin aging and improve
                        skin.
                    </p>
                    <ul className="list-disc list-inside text-gray-700 text-lg space-y-2">
                        <li>Amino acid 7</li>
                        <li>Hyaluronic acid with collagen</li>
                        <li>Peptide 2</li>
                        <li>Vitamins and Antioxidant 7</li>
                    </ul>
                </section>


                <section className="max-w-6xl mx-auto mb-16 ">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
                        <div className={'max-w-lg'}>
                            <img
                                src={image2}
                                alt="Ingredients"
                                className="rounded-lg w-full"
                            />
                        </div>
                        <div>
                            <h3 className="text-2xl font-bold  mb-4">INGREDIENTS
                            </h3>
                            <ul className="list-disc list-inside text-gray-700 text-lg space-y-4">
                                <li>
                                    <strong>7 Amino Acid:</strong> <br/> Isoleucine Alanine Histidine Arginine
                                    prolineglycine
                                    Leucine.
                                </li>
                                <li>
                                    <strong>7 Vitamins and Anti-oxidant:</strong> <br/>Biotin Dex panthenol Thiamine
                                    HCLNiacinamide Pyridoxine InositolCyanocobalamin.
                                </li>
                                <li>
                                    <strong>1 Sodium Hyaluronate:</strong> <br/>Non-crosslinked Low-molecular weight
                                    Hyaluronic acid 64mg/1ml.
                                </li>
                                <li>
                                    <strong>2 Peptide:</strong> <br/>Acetyl Tetrapeptide-2, acetyl Decapeptide-3.
                                </li>
                                <li>
                                    <strong>Hydrolyzed collagen:</strong> <br/>Hydrolyzed collagen 25mg/ml.
                                </li>
                            </ul>
                        </div>
                    </div>
                </section>


                <section className="max-w-6xl mx-auto mb-16">
                    <h3 className="text-2xl font-bold  mb-4">Benefits</h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
                        <div>
                            <ul className="list-disc list-inside text-gray-700 text-lg space-y-2 ">
                                <li>KEY BENEFITS</li>
                                <p>H2O collagen Booster maximizes skin elasticity and Anti-aging effectsH2O collagen
                                    Booster maximizes skin elasticity and Anti-aging effects with the best combination
                                    of 28 proven safe ingredients.
                                </p>
                                <li>Brighten the skin</li>
                                <li>Anti-Aging</li>
                                <li>Improving the density of dermis</li>
                                <li>Regenerating skin tissue</li>
                                <li>Repairing damaged collagen</li>
                                <li>Skin hydration</li>
                                <li>Optimized skin regeneration function and cell growth function</li>
                                <li>Strengthen skin elasticity in the dermis and epidermis & delivers ingredients that
                                    help improve skin tone
                                </li>
                                <li>Induce collagen production in fibroblasts in the dermis layer</li>
                                <li>Moisturize the skin effectively and maintain elasticity</li>
                                <li>Lifting effect</li>
                                <li>Restoring collagen and repairing photo-damaged collagen and elastin</li>
                                <li>Improving fine wrinkles</li>
                            </ul>
                        </div>
                        <div>
                            <img
                                src={image3}
                                alt="Benefits"
                                className="rounded-lg shadow-md w-full"
                            />
                        </div>
                    </div>
                </section>


                <section className="max-w-6xl mx-auto mb-16">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
                        <div>
                            <h3 className="text-2xl font-bold  mb-4">INDICATIONS</h3>

                            <ul className="list-disc list-inside  text-lg space-y-2 uppercase">
                                <li>Improving fine wrinkles</li>
                                <li>Improving dark circle</li>
                                <li>Improving crowfeet</li>
                                <li>Brighten skin tone
                                </li>
                            </ul>
                        </div>
                        <div>
                            <div className="relative  w-full h-full flex items-center justify-center">
                                {/* Background Image */}
                                <img
                                    src={image4}
                                    alt="Treatment Area"
                                    className="w-full h-full object-cover rounded-xl"
                                />

                                {/* Overlay Text */}
                                <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center">
                                    {/* Title */}
                                    <h2 className="absolute top-5 left-5 uppercase text-center text-black  text-sm">
                                        Explore by Treatment Area
                                    </h2>

                                    {/* Treatment Points */}
                                    {/* Undereye Hollows */}
                                    <div
                                        className="absolute left-[26%] top-[43%] flex  items-center gap-1 uppercase hover:bg-white hover:bg-opacity-50 py-1 px-2 rounded-2xl">
                                        <span className="text-black text-sm ">Undereye <br/>Hollows</span>
                                        <div className="w-3 h-3 bg-white bg-opacity-50 rounded-full"></div>

                                    </div>

                                    <div
                                        className="absolute left-[29%] top-[57%] flex  items-center gap-1 uppercase hover:bg-white hover:bg-opacity-50 py-1 px-2 rounded-2xl">
                                        <span className="text-black text-sm ">Cheeks</span>
                                        <div className="w-3 h-3 bg-white bg-opacity-50 rounded-full"></div>

                                    </div>

                                    <div
                                        className="absolute left-[46%] top-[67%] flex  items-center gap-1 uppercase hover:bg-white hover:bg-opacity-50 py-1 px-2 rounded-2xl">
                                        <div className="w-3 h-3 bg-white bg-opacity-50 rounded-full"></div>
                                        <span className="text-black text-sm ">Chin</span>
                                    </div>


                                    <div
                                        className="absolute left-[52.5%] top-[57.5%] flex  items-center gap-1 uppercase hover:bg-white hover:bg-opacity-50 py-1 px-2 rounded-2xl">
                                        <div className="w-3 h-3 bg-white bg-opacity-50 rounded-full"></div>
                                        <span className="text-black text-sm ">Lips</span>
                                    </div>

                                    <div
                                        className="absolute left-[54%] top-[45%] flex  items-center gap-1 uppercase hover:bg-white hover:bg-opacity-50 py-1 px-2 rounded-2xl">
                                        <div className="w-3 h-3 bg-white bg-opacity-50 rounded-full"></div>
                                        <span className="text-black text-sm ">
                                            Nasolabial <br/> folds
                                        </span>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="max-w-6xl mx-auto mb-16">
                    <div className=" max-w-2xl">
                        <h2 className="text-2xl md:text-3xl font-medium text-[#0C568E] mb-4">2. Extra Enhancement</h2>
                        <p className="text-gray-700 text-lg leading-relaxed mb-6">
                            Multi-ingredient rejuvenating formula dedicated for skin with moderate signs of ageing.
                            Extra
                            Enhancement enriched with hyaluronic acid is designed to quickly improve skin hydration and
                            firmness, as well as to eliminate the first wrinkles and signs of ageing.
                        </p>
                        <ul className="list-disc list-inside text-gray-700 text-lg space-y-4">
                            <li>
                                <strong>Key Benefits:</strong> <br/> >2000KDa HA - One of the highest molecular weights
                                of HA
                                within the skin booster market & a HA concentration of 144 mg per 4 ml.
                            </li>
                            <li>
                                <strong>Injection Technique:</strong> <br/> Extra Enhancement has a versatile injection
                                protocol.
                                Multiple methods of injection can be used including the BAP technique.
                            </li>
                            <li>
                                <strong>Hydrate:</strong> <br/> Extra Enhancement delivers intense, moisture-surging
                                skin-deep
                                hydration.
                            </li>
                            <li>
                                <strong>Glow:</strong><br/> The bio-stimulation of new collagen creates a beautiful and
                                glowing
                                appearance.
                            </li>
                        </ul>
                    </div>
                </section>


                <div className={"p-5 flex flex-col justify-center items-center"}>
                    <h1 className="text-2xl  mb-4 text-center">
                        CONCENTRATED AND MOST POWERFUL <br/> STIMULANT IN SKIN REDERMALIZATION AND <br/> ANTI-AGING
                        PREVENTION
                    </h1>

                    <div className="max-w-4xl mx-auto mb-16 my-10 relative">
                        <img src={image5} alt="Product" className="rounded-lg w-full"/>
                        <img src={image6} alt="Product" className="rounded-lg w-full absolute top-0 left-0 opacity-0 hover:opacity-100"/>
                    </div>

                    <Link to={'/products/mesotherapy'}>
                        <button
                            className="bg-none hover:bg-[#0C568E] hover:text-white border border-[#000] rounded-xl uppercase py-2 px-5 rounded">
                            View more Products
                        </button>
                    </Link>
                </div>
            </div>

        </div>
    );
};

export default Skin;